import { HeadingAttrs } from 'ui/theme/typographyAttrs/types'

export const getNoHeadingAttrs = (): HeadingAttrs => ({
  accessibilityRole: undefined,
  accessibilityLevel: 'p',
})
